/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

/* eslint-disable import/prefer-default-export */
import {
    // unitBase,
    rowSpacing,
    fontSizeDesktop,
    // fontSize,
    enterpriseCSS,
    paletteHD,
} from './variables';

import { StatusTrackingBar } from './common/StatusTrackingBar';

export const DesktopOrderListStyle = (typography, palette) => {
    const newPalette = !palette || !palette.cta1 ? paletteHD : palette;

    return {
        DesktopOrderListStyle: {
            maxWidth: newPalette.myAccount.container.maxWidth.upLarge,
            margin: '0 auto',
            marginBottom: rowSpacing,
            width: '1023px',
            '& .order-list-wrapper': {
                border: `2px solid ${enterpriseCSS.palette.gray3}`,
            },

            '& .orderHeader': {
                display: 'flex',
                fontSize: fontSizeDesktop.title,
                fontWeight: '700',
                textTransform: 'uppercase',
                padding: `${rowSpacing}px ${rowSpacing * 2}px`,
                backgroundColor: enterpriseCSS.palette.gray3,

                '& .orderHeaderItem': {
                    display: 'inline-block',

                    '& .headerItemLabel': {
                        color: enterpriseCSS.palette.gray1,
                    },

                    '& .partOrderNumber': {
                        fontWeight: 'normal',
                    },

                    '& .orderDate': {
                        textTransform: 'initial',
                    },
                },
            },

            '& .orderItemGrid': {
                display: 'block',
                padding: '12px 200px 50px',
                borderBottom: `1px solid ${newPalette.checkout?.borderColor}`,
                '&:not(:first-of-type) ': {
                    borderTop: `${'2px dashed'} ${enterpriseCSS.palette.gray3}`,
                },
            },

            '& .orderStatusInfo': {
                '& .orderDetail': {
                    marginTop: rowSpacing,
                    marginLeft: rowSpacing * 9,
                },
            },

            '& .productInnerDiv': {
                minHeight: rowSpacing * 11,
                position: 'relative',
                borderRadius: '3px',
                border: `1px solid ${newPalette.checkout?.borderColor}`,
                '& .headerItemLabel': {
                    padding: '15px 15px 15px 20px',
                    borderBottom: `1px solid ${newPalette.checkout?.borderColor}`,
                    backgroundColor: newPalette.desktopBgFooter,
                    fontWeight: 700,
                    fontSize: '17px',
                    letterSpacing: '0.5px',
                },
                '& .productImg': {
                    display: 'flex',
                    padding: '30px 0 30px 30px',
                    '& img': {
                        width: 190,
                        height: 220,
                        marginRight: '35px',
                    },
                    '& .productName': {
                        '& .subscription': {
                            marginTop: rowSpacing,
                            '& .subscriptionDelivery': {
                                display: 'block',
                            },
                        },
                        '& .productContainer': {
                            display: 'flex',
                            flexDirection: 'column',
                            height: '240px',
                            margin: '5px 0',
                        },
                        '& .productTitle': {
                            textTransform: 'none',
                            fontSize: '14px',
                            color: newPalette.common?.darkGray,
                            paddingBottom: '8px',
                            flexGrow: '2',
                        },
                        '& .productInfo': {
                            textTransform: 'none',
                            fontSize: '17px',
                            fontWeight: '700',
                            color: newPalette.common?.black,
                            margin: '5px 0',
                        },
                        '& .productId': {
                            color: enterpriseCSS.palette.gray1,
                            position: 'absolute',
                            bottom: 0,
                            textTransform: 'uppercase',
                            fontWeight: '700',
                            '& .productIdValue': {
                                fontWeight: 'normal',
                                textTransform: 'none',
                                color: enterpriseCSS.palette.body,
                            },
                        },
                    },
                },
            },
            // Status tracking bar
            ...StatusTrackingBar(typography, newPalette).StatusTrackingBar,
        },
    };
};
